<app-view-item *ngIf="disabled" [text]="displayText" [borderless]="borderless"></app-view-item>

<nz-select *ngIf="!disabled" nz-input [(ngModel)]="value" [nzDropdownMatchSelectWidth]="false"
  (ngModelChange)="onModelChange($event)" nzAllowClear="false" [style]="this.customStyle">
  <nz-option [nzValue]="item.value" [nzLabel]="item.label" *ngFor="let item of options"></nz-option>
</nz-select>